export const getPageCount = (totalCount: number, size: number) => {
  return Math.ceil(totalCount / size)
}
